export default __webpack_public_path__ + "static/media/img-tutor-howitworks-dashboard.451f446c.jpg";